<template>
  <div class="e_home">
    <div class="e_home_head">

      <Head :toptype="type"> </Head>
    </div>
    <!-- e_home_content -->
    <div class="e_home_content">
      <div class="e_home_left">
        <div class="e_home_left_top">
          <!-- head -->
          <div class="e_home_left_top_left">
            <span>数据概况</span>
          </div>
          <!--数据概况-->
          <div class="e_home_left_content">
            <div class="e_home_left_c_r">
              <CountTo :startVal="startVal" :endVal="1572" :duration="duration" :autoplay="autoplay" />
              <div class="e_home_left_c_r_text">总人数(个)</div>
            </div>
            <div class="e_home_left_c_l">
              <CountTo :startVal="startVal" :endVal="2254" :duration="duration" :autoplay="autoplay" />
              <div class="e_home_left_c_r_text">总碳量(吨)</div>
            </div>
          </div>
        </div>
        <div class="e_home_left_center">
          <!-- head -->
          <div class="e_home_left_top_left">
            <span>减碳排行榜</span>
          </div>
          <!-- 减碳排行榜 -->
          <div class="e_home_left_rank">
            <div class="e_home_left_rank_top">
              <div class="e_home_left_rank_title1">排名</div>
              <div class="e_home_left_rank_title2">昵称</div>
              <div class="e_home_left_rank_title3">住户地址</div>
              <div class="e_home_left_rank_title4">碳量</div>
            </div>
            <ul class="e_home_left_rank_ul">
              <li v-for="(item, index) in rankList" :key="item.version"
                :class="[index % 2 ? 'e_home_left_rank_li_odd' : 'e_home_left_rank_li_even']">
                <div class="e_home_left_rank_v"
                  :class="[item.version == 1 ? 'e_home_left_rank_v1' : item.version == 2 ? 'e_home_left_rank_v2' : item.version == 3 ? 'e_home_left_rank_v3' : '']">
                  {{ item.version }}</div>
                <div class="e_home_left_rank_n">{{ item.name }}</div>
                <div class="e_home_left_rank_a">{{ item.address }}</div>
                <div class="e_home_left_rank_m">{{ item.num }}</div>
              </li>
            </ul>
          </div>
        </div>
        <div class="e_home_left_bottom">
          <!-- head -->
          <div class="e_home_left_top_left">
            <span>碳量分布图</span>
          </div>
          <!-- 分布 -->
          <div id="line_echart"></div>
        </div>
      </div>
      <div class="e_home_center">
        <div class="e_home_center_top">
          <!-- 积分签到 -->
          <div class="e_home_center_top_title" @click="queryTab(0)">
            <div class="e_home_center_t_t1">积分签到</div>
            <div class="e_home_center_t_t2">66次</div>
          </div>
          <div class="e_home_center_top_list">
            <!-- 旧衣回收 --节水节电 -->
            <div class="e_home_center_top_title1" >
              <div class="e_home_center_top_title e_home_center_top_title2" @click="queryTab(1)">
                <div class="e_home_center_t_t1">旧衣回收</div>
                <div class="e_home_center_t_t2">48次</div>
              </div>
              <div class="e_home_center_top_title e_home_center_top_title3" @click="queryTab(2)">
                <div class="e_home_center_t_t1">节水节电</div>
                <div class="e_home_center_t_t2">148次</div>
              </div>
            </div>
            <!-- 光盘行动  ----绿色出行 -->
            <div class="e_home_center_top_title4">
              <div class="e_home_center_top_title e_home_center_top_title5" @click="queryTab(3)">
                <div class="e_home_center_t_t1">光盘行动</div>
                <div class="e_home_center_t_t2">14次</div>
              </div>
              <div class="e_home_center_top_title e_home_center_top_title6" @click="queryTab(4)">
                <div class="e_home_center_t_t1">绿色出行</div>
                <div class="e_home_center_t_t2">20次</div>
              </div>
            </div>
          </div>
        </div>
        <div class="e_home_center_bottom">
          <div class="e_home_right_title">{{ title }}</div>
          <div class="e_home_right_content">
            <div id="bubble_echart1"></div>
            <div id="bubble_echart2"></div>
            <div id="bubble_echart3"></div>
            <div id="bubble_echart4"></div>
          </div>
        </div>
      </div>
      <div class="e_home_right">
        <div class="e_home_right_top">
          <!-- head -->
          <div class="e_home_left_top_left">
            <span>数据分布图</span>
          </div>
          <!-- 数据分布图 -->
          <!-- 头部 今日 当月 今年 -->
          <div class="e_home_r_top">
            <div class="e_home_r_top1">
              <div class="e_home_r_top1_text">
                <div class="e_home_top1_t_l">110</div>
                <div class="e_home_top1_title">今日碳量(吨)</div>
              </div>
            </div>
            <div class="e_home_r_top2">
              <div class="e_home_r_top1_text">
                <div class="e_home_top1_t_l">850</div>
                <div class="e_home_top1_title">当月碳量(吨)</div>
              </div>
            </div>
            <div class="e_home_r_top3">
              <div class="e_home_r_top1_text">
                <div class="e_home_top1_t_l">1280</div>
                <div class="e_home_top1_title">今年碳量(吨)</div>
              </div>
            </div>
          </div>
          <div id="bution_echart"></div>
        </div>
        <div class="e_home_right_center">
          <!-- head -->
          <div class="e_home_left_top_left">
            <span>减碳分布图</span>
          </div>
          <div id="carbon_echart"></div>
        </div>
        <div class="e_home_right_bottom">
          <!-- head -->
          <div class="e_home_left_top_left">
            <span>碳普惠二维码</span>
          </div>
          <!-- 碳普惠二维码 -->
          <div class="e_home_qrcode">
            <div class="e_home_qrcode_img">
              <img src="../../assets/images/ma_i.png" alt="">
            </div>
            <div class="e_home_qrcode_map">
              <img src="../../assets/images/map.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import Head from "../../component/tophead.vue";
import CountTo from 'vue-count-to'
import 'echarts-liquidfill';
export default {
  data() {
    return {
      type: 1,
      startVal: 0, // 开始值
      duration: 3000, // 持续时间，毫秒
      autoplay: true, // 是否自动播放
      rankList: [
        { name: "大鲨鱼", address: "12号楼4单元2602", num: "9012kg", version: "1" },
        { name: "幸福一家人", address: "8号楼5单元202", num: "9012kg", version: "2" },
        { name: "H", address: "1号楼1单元2601", num: "9012kg", version: "3" },
        { name: "Y", address: "2号楼5单元2602", num: "9012kg", version: "4" },
        { name: "睡个好觉", address: "11号楼4单元2602", num: "9012kg", version: "5" },
        { name: "Leo", address: "1号楼4单元202", num: "9012kg", version: "6" },
        { name: "凯瑞", address: "8号楼7单元1602", num: "9012kg", version: "7" },
        { name: "肥胖小王", address: "9号楼3单元602", num: "9012kg", version: "8" },
        { name: "一尔", address: "4号楼1单元204", num: "9012kg", version: "9" },
      ],
      Charts: "",//减碳分布图
      bution: "",
      line: "",
      title: " ",
      balls: [
        { data1: 0.75, data2: 0.8, color: ['#0ac7f8', '#23c2fb'], name: "今日碳量", backgroundStyle: "rgba(34, 160, 231, 0.4)", value: 44.5 },
        { data1: 0.75, data2: 0.8, color: ['#e12324', '#dd5044'], name: "本周碳量", backgroundStyle: "rgba(222, 109, 71, 0.4)", value: 844.5 },
        { data1: 0.75, data2: 0.8, color: ['#0cf96a', '#21fb8a'], name: "本月碳量", backgroundStyle: "rgba(36, 225, 170, 0.4)", value: 1844.5 },
        { data1: 0.75, data2: 0.8, color: ['#b023f4', '#c043fb'], name: "今年碳量", backgroundStyle: "rgba(196, 71, 253, 0.4)", value: 1844.5 },
        // 添加更多水球配置
      ],
      echartsInstance: []
    };
  },
  components: {
    Head,
    CountTo
  },
  mounted() {
    this.queryCarbon()//获取碳量数据
    this.querydecarbon()//减碳分布图
    this.queryline()
    this.setRef()//水球图
  },
  methods: {
    queryTab(data) {
      if (data == 1) {
        this.title = "旧衣回收数据统计"
        this.balls = [
          { data1: 0.75, data2: 0.8, color: ['#0ac7f8', '#23c2fb'], name: "今日碳量", backgroundStyle: "rgba(34, 160, 231, 0.4)", value: 4.5 },
          { data1: 0.75, data2: 0.8, color: ['#e12324', '#dd5044'], name: "本周碳量", backgroundStyle: "rgba(222, 109, 71, 0.4)", value: 84.5 },
          { data1: 0.75, data2: 0.8, color: ['#0cf96a', '#21fb8a'], name: "本月碳量", backgroundStyle: "rgba(36, 225, 170, 0.4)", value: 184.5 },
          { data1: 0.75, data2: 0.8, color: ['#b023f4', '#c043fb'], name: "今年碳量", backgroundStyle: "rgba(196, 71, 253, 0.4)", value: 184.5 },
          // 添加更多水球配置
        ]
        this.setRef()//水球图
      } else if (data == 2) {
        this.title = "节水节电数据统计"
        this.balls = [
          { data1: 0.75, data2: 0.8, color: ['#0ac7f8', '#23c2fb'], name: "今日碳量", backgroundStyle: "rgba(34, 160, 231, 0.4)", value: 54.5 },
          { data1: 0.75, data2: 0.8, color: ['#e12324', '#dd5044'], name: "本周碳量", backgroundStyle: "rgba(222, 109, 71, 0.4)", value: 94.5 },
          { data1: 0.75, data2: 0.8, color: ['#0cf96a', '#21fb8a'], name: "本月碳量", backgroundStyle: "rgba(36, 225, 170, 0.4)", value: 284.5 },
          { data1: 0.75, data2: 0.8, color: ['#b023f4', '#c043fb'], name: "今年碳量", backgroundStyle: "rgba(196, 71, 253, 0.4)", value: 284.5 },
          // 添加更多水球配置
        ]
        this.setRef()//水球图
      } else if (data == 3) {
        this.title = "光盘行动数据统计"
        this.balls = [
          { data1: 0.75, data2: 0.8, color: ['#0ac7f8', '#23c2fb'], name: "今日碳量", backgroundStyle: "rgba(34, 160, 231, 0.4)", value: 6.5 },
          { data1: 0.75, data2: 0.8, color: ['#e12324', '#dd5044'], name: "本周碳量", backgroundStyle: "rgba(222, 109, 71, 0.4)", value: 64.5 },
          { data1: 0.75, data2: 0.8, color: ['#0cf96a', '#21fb8a'], name: "本月碳量", backgroundStyle: "rgba(36, 225, 170, 0.4)", value: 684.5 },
          { data1: 0.75, data2: 0.8, color: ['#b023f4', '#c043fb'], name: "今年碳量", backgroundStyle: "rgba(196, 71, 253, 0.4)", value: 684.5 },
          // 添加更多水球配置
        ]
        this.setRef()//水球图
      } else if (data == 4) {
        this.title = "绿色出行数据统计"
        this.balls = [
          { data1: 0.75, data2: 0.8, color: ['#0ac7f8', '#23c2fb'], name: "今日碳量", backgroundStyle: "rgba(34, 160, 231, 0.4)", value: 9.5 },
          { data1: 0.75, data2: 0.8, color: ['#e12324', '#dd5044'], name: "本周碳量", backgroundStyle: "rgba(222, 109, 71, 0.4)", value: 94.5 },
          { data1: 0.75, data2: 0.8, color: ['#0cf96a', '#21fb8a'], name: "本月碳量", backgroundStyle: "rgba(36, 225, 170, 0.4)", value: 984.5 },
          { data1: 0.75, data2: 0.8, color: ['#b023f4', '#c043fb'], name: "今年碳量", backgroundStyle: "rgba(196, 71, 253, 0.4)", value: 984.5 },
          // 添加更多水球配置
        ]
        this.setRef()//水球图
      } else {
        this.title = "  "
      }
    },
    queryCarbon() {
      this.Charts = this.$echarts.init(document.getElementById('carbon_echart'));
      const seriesData = [
        { value: 1048, name: '旧衣回收' },
        { value: 735, name: '节电节水' },
        { value: 580, name: '光盘行动' },
        { value: 484, name: '绿色出行' },
      ]
      const color = ['#61C88D', '#2159CE', '#F7BE55', '#DAD05F']
      var sum = 0;
      for (var i = 0; i < seriesData.length; i++) {
        sum = sum + seriesData[i].value;
      }
      var option = {
        legend: [
          {
            left: '56%',
            top: '50%',
            align: 'left',
            width: '65%',
            itemWidth: 12,             // 图例图形宽度
            itemHeight: 12,
            itemGap: 20,
            data: seriesData.slice(2, 4),
            textStyle: {
              align: 'left',
              verticalAlign: 'middle',
              rich: {
                name: {
                  color: '#FFFFFF',
                  fontSize: 12,
                  fontWeight: 500,
                  padding: [0, 0, 10, 5]
                },
                value: {
                  color: '#FFFFFF',
                  fontSize: 14,
                  padding: [0, 0, 0, -15]
                },
              },
            },
            formatter: params => {
              for (let a = 0; a < seriesData.length; a++) {
                // seriesData  这个数据中有名称和次数
                if (seriesData[a].name === params) {
                  //两个名称进行对比，取出对应的次数
                  let params1 = params + "\n" + seriesData[a].value; //然后return你需要的legend格式即可
                  let tmp = params1.split("\n");
                  let res = "" + params1;
                  for (let i in tmp) {
                    res = res.replace(tmp[i], "");
                  }
                  return `{name|${res}}{name|${params}}{value| ${"\n占比:" + (seriesData[a].value / sum * 100).toFixed(2) + '%'}}`;
                }
              }
            },
            x: "left"
          },
          {
            left: '56%',
            top: '25%',
            align: 'left',
            width: '65%',
            itemWidth: 12,             // 图例图形宽度
            itemHeight: 12,
            itemGap: 20,
            data: seriesData.slice(0, 2),
            textStyle: {
              align: 'left',
              verticalAlign: 'middle',
              rich: {
                name: {
                  color: '#FFFFFF',
                  fontSize: 12,
                  fontWeight: 500,
                  padding: [0, 0, 10, 5]
                },
                value: {
                  color: '#FFFFFF',
                  fontSize: 14,
                  padding: [0, 0, 0, -15]
                },
              },
            },
            formatter: params => {
              for (let a = 0; a < seriesData.length; a++) {
                // seriesData  这个数据中有名称和次数
                if (seriesData[a].name === params) {
                  //两个名称进行对比，取出对应的次数
                  let params1 = params + "\n" + seriesData[a].value; //然后return你需要的legend格式即可
                  let tmp = params1.split("\n");
                  let res = "" + params1;
                  for (let i in tmp) {
                    res = res.replace(tmp[i], "");
                  }
                  return `{name|${res}}{name|${params}}{value| ${"\n占比:" + (seriesData[a].value / sum * 100).toFixed(2) + '%'}}`;
                }
              }
            },
            x: "left"
          }
        ],
        tooltip: {
          show: true,
          formatter: '{b}:{d}%',
        },
        color: color,
        series: [
          {
            type: 'pie',
            radius: ["25%", "60%"],
            center: ["25%", "50%"],
            top: '2%', //单单指的饼图距离上面的距离，top越大饼图越小
            left: '0%', //单单指的饼图距离左面的距离，会改变饼图的大小
            avoidLabelOverlap: false, //做同心圆用到
            clockwise: false, //顺时针排列
            startAngle: 50, //起始角度 影响不大
            roseType: "radius", //area|radius
            label: {
              show: true, //false不显示饼图上的标签
              position: 'outside', //inside（在饼图上显示）,outside(默认就会出现引导线) center
              formatter: '{b}',
              color: '#FFFFFF',
              fontSize: 12,
            },
            //只有设置了label:show=ture;position=outside 设置labelLine才会有效
            labelLine: {
              show: true, //显示引导线
              length: 10, //连接饼图第1段线条的长度 length length2 不写自适应
              length2: 5, //链接饼图第2段线条长度
              smooth: true, //是否光滑连接线
            },
            itemStyle: {
              //每个扇形的设置
              borderColor: 'rgba(0,0,0,.1)', //扇形边框颜色
              borderWidth: 0, //扇形边框大小 要先给borderColor颜色 设置borderWidth才会有效果

            },
            data: [
              { value: 1048, name: '旧衣回收' },
              { value: 735, name: '节电节水' },
              { value: 580, name: '光盘行动' },
              { value: 484, name: '绿色出行' },
            ].sort((a, b) => b.value - a.value), //数组从大到小排序

            emphasis: {
              scale: true,
              scaleSize: 10,

              //启用鼠标放上去放大效果，这个挺好的
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      };
      setTimeout(() => {
        this.Charts.setOption(option)
      }, 700)
      window.addEventListener("resize", () => {
        this.Charts.resize(); // 窗口发生改变就更新echarts
      });
    },
    querydecarbon() {
      this.bution = this.$echarts.init(document.getElementById('bution_echart'));
      var data = [
        [
          [34, 57,],
          [43, 37.4,],
          [23, 58,],
          [54, 34.7,],
          [23, -15,],
          [87, 27.1,],
          [67, 65.4,],
          [56, -57.7,],
          [35, 35.1,],
          [46, -67.9,]
        ],
        [
          [86, 50.8,],
          [56, -41.7,],
          [34, 26.9,],
          [76, 58.5,],
          [24, -20.8,],
          [56, -41.9,],
          [10, 11,],
          [46, 42.8,],
          [75, -73.8,],
          [24, 33.5,],
          [68, 29.4,]
        ],
        [
          [10, 50,],
          [18, 33,],
          [5, 42,],
          [50, 47,],
          [20, 50,],
          [8, 45,],
          [56, 10,],
          [50, 15,],
          [44, 10,],
          [56, 57.7,],
          [56, -57.7,],
        ],
      ];
      var options = {
        grid: {
          left: '10%',
          right: '10%',
          top: '10%',
          bottom: '10%',
        },
        tooltip: {
          show: false
        },
        color: ['#24DEFC', '#F0BA32', '#36D665'],
        legend: {
          center: 'center',
          top: '5%',
          textStyle: {
            fontSize: 12,
            color: 'rgba(255,255,255,.8)',
          },
          data: ['今日碳量', '当月碳量', '今年碳量'],
        },

        xAxis: {
          show: false,
        },
        yAxis: {
          show: false,
          scale: true,
        },
        series: [
          {
            name: '今日碳量',
            data: data[0],
            type: 'scatter',
            symbolSize: function (data) {
              return data[1];
            },
            label: {
              emphasis: {
                show: false,
              },
            },
          },
          {
            name: '当月碳量',
            data: data[1],
            type: 'scatter',
            symbolSize: function (data) {
              return data[0];
            },
            label: {
              emphasis: {
                show: false,
              },
            },
          },
          {
            name: '今年碳量',
            data: data[2],
            type: 'scatter',
            symbolSize: function (data) {
              return data[0];
            },
            label: {
              emphasis: {
                show: false,
              },
            },
          },
        ],
      };
      setTimeout(() => {
        this.bution.setOption(options)
      }, 700)
      window.addEventListener("resize", () => {
        this.bution.resize(); // 窗口发生改变就更新echarts
      });

    },
    queryline() {
      this.line = this.$echarts.init(document.getElementById('line_echart'));
      var barWidth = 8;
      var normalColor = "#657CA8";
      var datas = {
        xdata: ['11月25', '11月26', '11月27', '11月28', '11月29', '11月30'],
        yData1: [4200, 3220, 3910, 5340, 5670, 5896],
        yData2: [3200, 2220, 3610, 4940, 5432, 5478],
        yData3: [2800, 2798, 3287, 4634, 4897, 5213],
        yData4: [2456, 2387, 2865, 4321, 4456, 4897],
        yData5: [17659, 19873, 12907, 15785, 17845, 19845],
        legendData: ['衣', '食', '住', '行'],
      }
      var option = {
        animation: false, //去除加载时缓动动画
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          show: true,
          top: "4%",
          selectedMode: false, //取消图例上的点击事件
          data: datas.legendData,
          itemWidth: 13,
          itemHeight: 4,
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
        },
        grid: {
          top: '10%',
          right: '1%',
          left: '15%',
          bottom: '12%'
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: '#51BFFF',
            interval: 0, fontSize: 14,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#0a3e98'
            }
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#195384',
              type: "dotted",
            }
          },
          data: datas.xdata,
        },
        yAxis: [{
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,

          },
          type: 'value',
          name: '',
          nameTextStyle: {
            color: "#7ECEF4",
            fontSize: 12,
          },
          axisLabel: {
            formatter: '{value} kg',
            textStyle: {
              color: "#7ECEF4", fontSize: 12,
            }
          }
        },
        {
          type: 'value',
          nameTextStyle: {
            color: "#7ECEF4",
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,

          },
          name: '',
          axisLabel: {
            formatter: '{value} 吨',
            textStyle: {
              color: "#7ECEF4", fontSize: 12,
            }
          }
        }],
        series: [
          // 网络点数
          { // 蓝色柱子
            name: datas.legendData[0],
            tooltip: {
              show: true
            },
            type: 'bar',
            barWidth: barWidth, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {
              normal: {
                color: '#14F0F9'
              }
            },
            data: datas.yData1,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' kg';
              }
            },
            barGap: 0,
            legendHoverLink: false,
          },
          {
            name: datas.legendData[1],
            type: 'bar',
            // stack: 1,
            barWidth: barWidth, //柱子宽度
            barGap: 0.5, //柱子之间间距
            itemStyle: {
              normal: {
                color: '#FEB71E'

              }
            },
            data: datas.yData2,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' kg';
              }
            },
          },
          {
            // 红色柱子
            name: datas.legendData[2],
            type: 'bar',
            // stack: 1,
            barWidth: barWidth, //柱子宽度
            barGap: 0.5, //柱子之间间距
            tooltip: {
              valueFormatter: function (value) {
                return value + ' kg';
              }
            },

            itemStyle: {
              normal: {
                color: '#1DFF5D'

              }
            },
            data: datas.yData3,
          },

          // 巡查问题数
          // 整改完成数
          {

            name: datas.legendData[3],
            type: 'bar',
            // stack: 1,
            barWidth: barWidth, //柱子宽度
            barGap: 0.5, //柱子之间间距
            tooltip: {
              valueFormatter: function (value) {
                return value + ' kg';
              }
            },
            itemStyle: {
              normal: {
                color: '#F25194'

              }
            },
            data: datas.yData4,
          },

          // 整改完成数
          // 整改率
          {
            name: "总碳量",
            type: 'line',
            symbolSize: 8,
            symbol: "circle",
            smooth: true,
            tooltip: {
              valueFormatter: function (value) {
                return value + ' 吨';
              }
            },
            yAxisIndex: 1,
            z: 22,
            itemStyle: {
              normal: {
                color: "#7BC9E3"
              }
            },
            lineStyle: {
              width: 2,
              color: "#7BC9E3"
            },
            data: datas.yData5,
          },

        ]

      };
      setTimeout(() => {
        this.line.setOption(option)
      }, 700)
      window.addEventListener("resize", () => {
        this.line.resize(); // 窗口发生改变就更新echarts
      });
    },
    setRef() {
      this.$nextTick(() => {
        this.setLine1()
        this.setLine2()
        this.setLine3()
        this.setLine4()
      })
    },
    setLine1() {
      var that = this
      var myChart = this.$echarts.init(document.getElementById('bubble_echart1'));
      const option = {
        title: {
          text: that.balls[0].name,
          left: 'center',
          top: "50%",
          textStyle: {
            color: '#fff',
            fontWeight: 'normal',
            fontSize: 16,
          },
        },
        series: [
          {
            type: 'liquidFill',
            radius: '95%',
            center: ['50%', '50%'],
            data: [that.balls[0].data1, that.balls[0].data2], // data个数代表波浪数
            color: [that.balls[0].color],
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderWidth: 2,
                borderColor: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#007DFF',
                    },
                    {
                      offset: 0.6,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                  ],
                  globalCoord: false,
                },
              },
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(22, 22, 22, 0.5)',
                shadowBlur: 10,
              },
            },
            backgroundStyle: {
              borderWidth: 1,
              color: that.balls[0].backgroundStyle, // 球体本景色
            },
            amplitude: '6%', //波浪的振幅
            label: {
              position: ['50%', '40%'],
              formatter: that.balls[0].value + '{b|吨}',
              rich: {
                b: {

                  fontSize: 14,
                  color: '#fff'
                },
              },
              textStyle: {
                color: '#fff',
                fontSize: 30,
              },
            },
          },
        ],
      };
      setTimeout(() => {
        myChart.setOption(option)
      }, 700)
      window.addEventListener("resize", () => {
        myChart.resize(); // 窗口发生改变就更新echarts
      });
    },
    setLine2() {
      var that = this
      var myChar1 = this.$echarts.init(document.getElementById('bubble_echart2'));
      const option = {
        title: {
          text: that.balls[1].name,
          left: 'center',
          top: "50%",
          textStyle: {
            color: '#fff',
            fontWeight: 'normal',
            fontSize: 16,
          },
        },
        series: [
          {
            type: 'liquidFill',
            radius: '95%',
            center: ['50%', '50%'],
            data: [that.balls[1].data1, that.balls[1].data2], // data个数代表波浪数
            color: [that.balls[1].color],
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderWidth: 2,
                borderColor: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#007DFF',
                    },
                    {
                      offset: 0.6,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                  ],
                  globalCoord: false,
                },
              },
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(22, 22, 22, 0.5)',
                shadowBlur: 10,
              },
            },
            backgroundStyle: {
              borderWidth: 1,
              color: that.balls[1].backgroundStyle, // 球体本景色
            },
            amplitude: '6%', //波浪的振幅
            label: {
              position: ['50%', '40%'],
              formatter: that.balls[1].value + '{b|吨}',
              rich: {
                b: {

                  fontSize: 14,
                  color: '#fff'
                },
              },
              textStyle: {
                color: '#fff',
                fontSize: 30,
              },
            },
          },
        ],
      };
      setTimeout(() => {
        myChar1.setOption(option)
      }, 700)
      window.addEventListener("resize", () => {
        myChar1.resize(); // 窗口发生改变就更新echarts
      });
    },
    setLine3() {
      var that = this
      var myChart2 = this.$echarts.init(document.getElementById('bubble_echart3'));
      const option = {
        title: {
          text: that.balls[2].name,
          left: 'center',
          top: "50%",
          textStyle: {
            color: '#fff',
            fontWeight: 'normal',
            fontSize: 16,
          },
        },
        series: [
          {
            type: 'liquidFill',
            radius: '95%',
            center: ['50%', '50%'],
            data: [that.balls[2].data1, that.balls[2].data2], // data个数代表波浪数
            color: [that.balls[2].color],
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderWidth: 2,
                borderColor: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#007DFF',
                    },
                    {
                      offset: 0.6,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                  ],
                  globalCoord: false,
                },
              },
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(22, 22, 22, 0.5)',
                shadowBlur: 10,
              },
            },
            backgroundStyle: {
              borderWidth: 1,
              color: that.balls[2].backgroundStyle, // 球体本景色
            },
            amplitude: '6%', //波浪的振幅
            label: {
              position: ['50%', '40%'],
              formatter: that.balls[2].value + '{b|吨}',
              rich: {
                b: {

                  fontSize: 14,
                  color: '#fff'
                },
              },
              textStyle: {
                color: '#fff',
                fontSize: 30,
              },
            },
          },
        ],
      };
      setTimeout(() => {
        myChart2.setOption(option)
      }, 700)
      window.addEventListener("resize", () => {
        myChart2.resize(); // 窗口发生改变就更新echarts
      });
    },
    setLine4() {
      var that = this
      var myChart3 = this.$echarts.init(document.getElementById('bubble_echart4'));
      const option = {
        title: {
          text: that.balls[3].name,
          left: 'center',
          top: "50%",
          textStyle: {
            color: '#fff',
            fontWeight: 'normal',
            fontSize: 16,
          },
        },
        series: [
          {
            type: 'liquidFill',
            radius: '95%',
            center: ['50%', '50%'],
            data: [that.balls[3].data1, that.balls[3].data2], // data个数代表波浪数
            color: [that.balls[3].color],
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderWidth: 2,
                borderColor: {
                  type: 'linear',
                  x: 1,
                  y: 0,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#007DFF',
                    },
                    {
                      offset: 0.6,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                    {
                      offset: 1,
                      color: 'rgba(45, 67, 114, 1)',
                    },
                  ],
                  globalCoord: false,
                },
              },
            },
            itemStyle: {
              normal: {
                shadowColor: 'rgba(22, 22, 22, 0.5)',
                shadowBlur: 10,
              },
            },
            backgroundStyle: {
              borderWidth: 1,
              color: that.balls[3].backgroundStyle, // 球体本景色
            },
            amplitude: '6%', //波浪的振幅
            label: {
              position: ['50%', '40%'],
              formatter: that.balls[3].value + '{b|吨}',
              rich: {
                b: {

                  fontSize: 14,
                  color: '#fff'
                },
              },
              textStyle: {
                color: '#fff',
                fontSize: 30,
              },
            },
          },
        ],
      };
      setTimeout(() => {
        myChart3.setOption(option)
      }, 700)
      window.addEventListener("resize", () => {
        myChart3.resize(); // 窗口发生改变就更新echarts
      });
    },

  },
};
</script>
<style lang="scss" scoped>
.e_home {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;

  .e_home_content {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    position: relative;
    justify-content: space-between;
    padding: 25px 19px 0px 20px;

    .e_home_left_top_left {
      background: url('../../assets/images/head.png') no-repeat;
      background-size: 100% 100%;
      width: 444px;
      height: 39px;

      span {
        line-height: 39px;
        font-weight: bold;
        font-size: 16px;
        color: #FFFFFF;
        margin-left: 42px;
      }
    }

    .e_home_left {
      width: 444px;
      height: auto;

      .e_home_left_top {
        background: url('../../assets/images/zc_lh1.png') no-repeat;
        background-size: 100% 100%;
        width: 444px;
        height: 258px;

        .e_home_left_content {
          display: flex;
          flex-wrap: wrap;
          padding: 24px 18px 0px 22px;
          justify-content: space-between;

          .e_home_left_c_r {
            width: 192px;
            height: 156px;
            background: url('../../assets/images/num_g.png') no-repeat;
            background-size: 100% 100%;
            text-align: center;

            span {
              font-size: 30px;
              font-weight: bold;
              color: #FFFFFF;
              margin-top: 45px;
              display: inline-block;

            }

            .e_home_left_c_r_text {
              font-size: 16px;
              color: #FFFFFF;
              margin-top: 6px;
            }
          }

          .e_home_left_c_l {
            width: 192px;
            height: 156px;
            background: url('../../assets/images/num_h.png') no-repeat;
            background-size: 100% 100%;
            text-align: center;

            span {
              font-size: 30px;
              font-weight: bold;
              color: #FFFFFF;
              margin-top: 45px;
              display: inline-block;

            }

            .e_home_left_c_r_text {
              font-size: 16px;
              color: #FFFFFF;
              margin-top: 6px;
            }
          }
        }
      }

      .e_home_left_center {
        background: url('../../assets/images/zc_lh2.png') no-repeat;
        background-size: 100% 100%;
        width: 444px;
        height: 353px;
        margin-top: 17px;
        overflow: hidden;

        .e_home_left_rank_top {
          display: flex;
          font-weight: 400;
          font-size: 14px;
          color: #2AFFDE;
          flex-wrap: wrap;
          height: 46px;
          line-height: 46px;
          padding: 0px 14px;

          .e_home_left_rank_title1 {
            width: 10%;
          }

          .e_home_left_rank_title2 {
            width: 30%;
            text-align: center;
          }

          .e_home_left_rank_title3 {
            width: 38%;
            text-align: center;
          }

          .e_home_left_rank_title4 {
            width: 22%;
            text-align: center;

          }
        }

        .e_home_left_rank_ul {
          li {
            display: flex;
            width: 445px;
            padding: 0px 14px;
            font-size: 14px;
            color: #EEEEEE;
            align-items: center;

            .e_home_left_rank_v {
              width: 26px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 20px;
            }

            .e_home_left_rank_v1 {
              background: url('../../assets/images/ran_k1.png') no-repeat;
              background-size: 100% 100%;
              width: 26px;
              height: 24px;
            }

            .e_home_left_rank_v3 {
              background: url('../../assets/images/ran_k3.png') no-repeat;
              background-size: 100% 100%;
              width: 26px;
              height: 24px;
            }

            .e_home_left_rank_v2 {
              background: url('../../assets/images/ran_k2.png') no-repeat;
              background-size: 100% 100%;
              width: 26px;
              height: 24px;
            }

            .e_home_left_rank_n {
              width: 30%;
              text-align: center;
            }

            .e_home_left_rank_a {
              width: 38%;
              text-align: center;
            }

            .e_home_left_rank_m {
              width: 22%;
              text-align: center;
            }
          }

          .e_home_left_rank_li_odd {
            height: 31.8px;
          }

          .e_home_left_rank_li_even {
            background: #0C363B;
            height: 35px;

          }
        }
      }

      .e_home_left_bottom {
        background: url('../../assets/images/zc_lh3.png') no-repeat;
        background-size: 100% 100%;
        width: 444px;
        height: 310px;
        margin-top: 18px;

        #line_echart {
          height: 271px;
          width: 444px;
        }
      }
    }

    .e_home_center {
      width: 901px;
      margin: 0 auto;

      .e_home_center_top {
        background: url('../../assets/images/center.png') no-repeat;
        background-size: 100% 100%;
        width: 695px;
        height: 493px;
        position: relative;
        left: 100px;

        .e_home_center_top_title {
          text-align: center;
          width: 125px;
          position: relative;
          left: 390px;
          top: 50px;

          .e_home_center_t_t1 {
            height: 35px;
            line-height: 35px;
            font-size: 20px;
            color: #01E3E5;
          }

          .e_home_center_t_t2 {
            height: 35px;
            line-height: 35px;
            margin-top: 6px;
            color: #F2C52A;
            font-size: 18px;
            text-align: right;
            margin-right: 20px;
          }
        }

        .e_home_center_top_list {
          display: flex;
          flex-wrap: wrap;
        }

        .e_home_center_top_title1 {
          position: relative;
          text-align: left;
          top: 93px;
          width: 50%;
        }

        .e_home_center_top_title2 {
          position: relative;
          text-align: left;
          left: 20px;
          top: 0px;

          .e_home_center_t_t2 {
            text-align: left;
          }
        }

        .e_home_center_top_title3 {
          position: relative;
          text-align: left;
          left: 40px;
          top: 110px;

          .e_home_center_t_t2 {
            text-align: left;
          }
        }

        .e_home_center_top_title4 {
          position: relative;
          left: 210px;
          width: 50%;
          top: 92px;
        }

        .e_home_center_top_title5 {
          position: relative;
          left: 0px;
          top: 0px;
        }

        .e_home_center_top_title6 {
          position: relative;
          left: -15px;
          top: 112px;
        }
      }

      .e_home_center_bottom {
        display: flex;
        flex-wrap: wrap;
        padding: 0px 46px 0px 31px;
        height: 100px;
        margin-top: 171px;

        .e_home_right_title {
          color: #ffff;
          font-size: 16px;
          margin-left: 30px
        }

        .e_home_right_content {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          margin-top: 26px;


          #bubble_echart1 {
            width: 206px;
            height: 166px;
          }

          #bubble_echart2 {
            width: 206px;
            height: 166px;
          }

          #bubble_echart3 {
            width: 206px;
            height: 166px;
          }

          #bubble_echart4 {
            width: 206px;
            height: 166px;
          }
        }

      }
    }

    .e_home_right {
      width: 444px;
      height: auto;

      .e_home_right_top {
        background: url('../../assets/images/zc_rh1.png') no-repeat;
        background-size: 100% 100%;
        width: 444px;
        height: 487px;

        .e_home_r_top {
          display: flex;
          flex-wrap: wrap;
          padding: 19px 9px 0px 14px;
          justify-content: space-between;

          .e_home_r_top1 {
            background: url('../../assets/images/zc_e_3.png') no-repeat;
            background-size: 100% 100%;
            width: 130px;
            height: 50px;
            display: flex;
            align-items: center;
          }

          .e_home_r_top2 {
            background: url('../../assets/images/zc_e_2.png') no-repeat;
            background-size: 100% 100%;
            width: 130px;
            height: 50px;
            display: flex;
            align-items: center;
          }

          .e_home_r_top3 {
            background: url('../../assets/images/zc_e_1.png') no-repeat;
            background-size: 100% 100%;
            width: 130px;
            height: 50px;
            display: flex;
            align-items: center;
          }

          .e_home_r_top1_text {
            margin-left: 51px;

            .e_home_top1_t_l {
              font-weight: 400;
              font-size: 19px;
              color: #FFFFFF;
            }

            .e_home_top1_title {
              font-size: 12px;
              color: #FFFFFF;
            }
          }
        }

        #bution_echart {
          height: 379px;
          width: 444px;
        }
      }

      .e_home_right_center {
        background: url('../../assets/images/zc_rh2.png') no-repeat;
        background-size: 100% 100%;
        width: 444px;
        height: 258px;
        margin-top: 15px;

        #carbon_echart {
          height: 218px;
          width: 444px;
        }
      }

      .e_home_right_bottom {
        background: url('../../assets/images/zc_rh3.png') no-repeat;
        background-size: 100% 100%;
        width: 444px;
        height: 177px;
        margin-top: 16px;

        .e_home_qrcode {
          display: flex;
          flex-wrap: wrap;
          align-items: center;

          .e_home_qrcode_img {
            width: 143px;
            height: 132px;
            margin-top: 4px;
            margin-left: 55px;

            img {
              width: 143px;
              height: 132px;

            }

          }

          .e_home_qrcode_map {
            width: 112px;
            height: 112px;
            margin-left: 66px;

            img {
              width: 112px;
              height: 112px;
            }
          }
        }
      }
    }
  }
}
</style>